(ns frontend.view.settings2.counterparty-diligence.event
  (:require
   [clojure.edn :as edn]
   [clojure.string :as string]
   [common.email :as email]
   [common.localization :as loc]
   [frontend.controller.websocket.event :as ws]
   [frontend.global-events.toast :as toast]
   [frontend.state.current-session :as session]
   [frontend.view.settings2.counterparty-diligence.model :as model]
   [potpuri.core :as p]
   [re-frame.core :as rf]))

(def ^:private inject-tenant-interceptor
  (rf/->interceptor
   {:id     ::inject-tenant
    :before (fn [args]
              (let [tenant @session/tenant]
                (assoc-in args [:coeffects :tenant] tenant)))}))

(defn- parse-config
  [tenant]
  (let [raw (:tenant/counterparty-diligence-config tenant)]
    (cond
      (map? raw)    raw
      (string? raw) (try (edn/read-string raw)
                         (catch :default _ {}))
      :else         {})))

(defn- parse-recipients-input
  "Split a comma/semicolon/whitespace separated string into a clean vector
   of trimmed non-empty emails."
  [s]
  (->> (string/split (or s "") #"[,;\s]+")
       (map string/trim)
       (remove string/blank?)
       vec))

(defn- format-recipients
  [recipients]
  (string/join ", " (or recipients [])))

(rf/reg-event-fx
 ::init-editor
 [inject-tenant-interceptor]
 (fn [{:keys [db tenant]}]
   (let [config (parse-config tenant)
         notifications (get config :notifications {})
         inputs (->> notifications
                     (map (fn [[id v]]
                            [id (format-recipients (:recipients v))]))
                     (into {}))]
     {:db (-> db
              (assoc-in model/config-full-path config)
              (assoc-in (conj model/root-path :recipients-input) inputs))})))

(rf/reg-event-db
 ::set-recipients-input
 [rf/trim-v]
 (fn [db [notification-id input-str]]
   (let [parsed (parse-recipients-input input-str)]
     (-> db
         (assoc-in (conj model/root-path :recipients-input notification-id) input-str)
         (assoc-in (concat model/config-full-path [:notifications notification-id :recipients])
                   parsed)
         (update-in (conj model/root-path model/invalid-emails-key) dissoc notification-id)))))

(rf/reg-event-fx
 ::save-changes-done
 [rf/trim-v]
 (fn [{:keys [db]} [success? _resp]]
   (merge
    {:db (p/dissoc-in db model/saving-full-path)}
    (if success?
      {::toast/success (loc/tr :all-changes-saved)}
      {::toast/error (loc/tr :an-error-occurred)}))))

(rf/reg-event-fx
 ::save-changes
 (fn [{:keys [db]}]
   (let [config (get-in db model/config-full-path)
         invalid-by-id (->> (:notifications config)
                            (keep (fn [[id {:keys [recipients]}]]
                                    (let [invalid (->> recipients
                                                       (remove email/valid-email-pattern?)
                                                       vec)]
                                      (when (seq invalid)
                                        [id invalid]))))
                            (into {}))]
     (if (seq invalid-by-id)
       {:db (assoc-in db (conj model/root-path model/invalid-emails-key) invalid-by-id)
        ::toast/error (loc/tr :counterparty-diligence-settings/invalid-emails-toast)}
       {:db (-> db
                (assoc-in model/saving-full-path true)
                (update-in model/root-path dissoc model/invalid-emails-key))
        ::ws/send {:id :tenant/update-counterparty-diligence-config
                   :body {:config config}
                   :on-success [::save-changes-done true]
                   :on-error [::save-changes-done false]}}))))

(rf/reg-event-db
 ::open-preview
 [rf/trim-v]
 (fn [db [notification-id]]
   (-> db
       (assoc-in model/preview-notification-id-full-path notification-id)
       (update-in model/root-path dissoc model/preview-variant-template-id-key))))

(rf/reg-event-db
 ::close-preview
 (fn [db]
   (-> db
       (p/dissoc-in model/preview-notification-id-full-path)
       (update-in model/root-path dissoc model/preview-variant-template-id-key))))

(rf/reg-event-db
 ::select-preview-variant
 [rf/trim-v]
 (fn [db [template-id]]
   (assoc-in db (conj model/root-path model/preview-variant-template-id-key) template-id)))
